<template>
    <v-list two-line>
        <template v-for="(item, index) in playables">
            <playables-list-item :data="item" :routable="true"></playables-list-item>
            <v-divider v-if="index + 1 < playables.length"></v-divider>
        </template>
    </v-list>
</template>

<script>
import PlayablesListItem from '@/components/PlayablesListItem.vue'
export default {
  name: 'playables-list',
  components: { PlayablesListItem },
  props: {
    playables: Array
  }
}
</script>

<style scoped>

</style>